/* ==========================================================================
   whero-social-proof.js
   --------------------------------------------------------------------------
   Fetches approved reviews from the Shopify app proxy at /apps/api/reviews/live
   and swaps the server-rendered fallback cards for live ones. On any failure,
   the fallback stays visible — no blank state.
   ========================================================================== */
(function () {
  'use strict';

  var PROXY_URL = '/apps/api/reviews/live';
  var TIMEOUT_MS = 3000;
  var MAX_QUOTE_LEN = 240;

  function init() {
    var section = document.querySelector('[data-whero-social]');
    if (!section) return;
    if (section.dataset.useLiveFeed === 'false') return;

    var grid = section.querySelector('[data-whero-social-grid]');
    if (!grid) return;

    var maxCards = parseInt(section.dataset.maxCards, 10) || 3;

    var ctl = null;
    try { ctl = new AbortController(); } catch (_) {}
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, TIMEOUT_MS) : null;
    var opts = ctl ? { signal: ctl.signal, credentials: 'same-origin' } : { credentials: 'same-origin' };

    fetch(PROXY_URL, opts)
      .then(function (r) {
        if (timer) { clearTimeout(timer); timer = null; }
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var reviews = data && Array.isArray(data.reviews) ? data.reviews : [];
        if (reviews.length === 0) return;

        var picked = pickReviews(reviews, maxCards);
        if (picked.length === 0) return;

        var frag = document.createDocumentFragment();
        for (var i = 0; i < picked.length; i++) {
          frag.appendChild(buildCard(picked[i]));
        }
        grid.replaceChildren(frag);
      })
      .catch(function (err) {
        if (timer) { clearTimeout(timer); timer = null; }
        console.warn('[whero-social] Live feed unavailable — fallback shown:', (err && err.message) || err);
      });
  }

  // Deterministic daily shuffle so the order is stable within a single day
  // but rotates between visits on different days.
  function seededShuffle(arr, seed) {
    var a = arr.slice();
    var s = seed;
    for (var i = a.length - 1; i > 0; i--) {
      s = (s * 9301 + 49297) % 233280;
      var j = Math.floor((s / 233280) * (i + 1));
      var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
    }
    return a;
  }

  function todaySeed() {
    var d = new Date();
    // YYYYMMDD as an int.
    return d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate();
  }

  function pickReviews(reviews, n) {
    var eligible = reviews.filter(function (r) {
      return r && typeof r.quote === 'string' && r.quote.length <= MAX_QUOTE_LEN;
    });

    if (eligible.length >= n) {
      return seededShuffle(eligible, todaySeed()).slice(0, n);
    }
    // Not enough short quotes — fall back to the top-N regardless of length.
    // The bridge already returns them rating-desc / newest-first.
    return reviews.slice(0, n);
  }

  function platformLabel(review) {
    var explicit = review && typeof review.source_platform === 'string'
      ? review.source_platform.trim()
      : '';
    if (explicit) return explicit;

    var source = review && review.source;
    if (source === 'google') return 'Google';
    if (source === 'toast') return 'In-shop';
    if (source === 'manual') return "Wynston's";
    return '';
  }

  function cityLabel(loc) {
    if (loc === 'san-marcos') return 'San Marcos';
    if (loc === 'torrey-highlands') return 'San Diego';
    return ''; // 'both' or unknown → omit
  }

  function sourceLine(review) {
    var platform = platformLabel(review);
    var city = cityLabel(review.source_location);
    if (platform && city) return platform + ' \u00B7 ' + city;
    return platform || city;
  }

  function initial(name) {
    if (!name) return '';
    var ch = name.trim().charAt(0);
    return ch ? ch.toUpperCase() : '';
  }

  function starsString(rating) {
    var n = Math.max(0, Math.min(5, Math.round(rating || 0)));
    var out = '';
    for (var i = 0; i < n; i++) out += '\u2605';
    return out;
  }

  function el(tag, className) {
    var e = document.createElement(tag);
    if (className) e.className = className;
    return e;
  }

  function buildCard(review) {
    var article = el('article', 'whero-social__card');

    var bq = el('blockquote', 'whero-social__quote');
    var p = document.createElement('p');
    p.textContent = '\u201C' + (review.quote || '') + '\u201D';
    bq.appendChild(p);
    article.appendChild(bq);

    var footer = el('footer', 'whero-social__who');

    var avatar = el('div', 'whero-social__avatar');
    avatar.setAttribute('aria-hidden', 'true');
    avatar.textContent = initial(review.author_display);
    footer.appendChild(avatar);

    var meta = el('div', 'whero-social__meta');

    var name = el('div', 'whero-social__name');
    name.textContent = review.author_display || '';
    meta.appendChild(name);

    var src = sourceLine(review);
    if (src) {
      var source = el('div', 'whero-social__source');
      source.textContent = src;
      meta.appendChild(source);
    }

    var rating = Math.max(0, Math.min(5, Math.round(review.rating || 0)));
    var stars = el('div', 'whero-social__stars');
    stars.setAttribute('aria-label', rating + ' out of 5 stars');
    stars.textContent = starsString(rating);
    meta.appendChild(stars);

    footer.appendChild(meta);
    article.appendChild(footer);

    return article;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
